import { useMutation } from '@tanstack/react-query'
import { updateDob } from 'api/user'

export function useUpdateDobMutation(
  userId: string,
  options?: {
    onSuccess?: () => void
    onError?: (error: Error) => void
  }
) {
  return useMutation({
    mutationFn: (dob: string) => updateDob(userId, dob),
    ...options,
  })
}
